import noImageAvailable from './assets/images/no_image_available.jpg';
export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL;
export const SSE_BASE_URL =
  import.meta.env.VITE_SSE_BASE_URL ||
  'https://stg-cs-stream-api.samsunghrm.com/api/sse';
export const NO_IMAGE = noImageAvailable;
export const MONITOR_GUIDEBASEURL =
  'https://resources.samsunghrm.com/DESCRIPTION/Monitoring_guide';
export const GUIDEBASEURL =
  'https://resources.samsunghrm.com/DESCRIPTION/Guide_';

export const VITE_AUTH_USER_NAME = import.meta.env.VITE_AUTH_USER_NAME;
export const VITE_AUTH_ACCESS_TOKEN = import.meta.env.VITE_AUTH_ACCESS_TOKEN;
